import ComponentManager from '@/Management/ComponentManager';
import Control from '@/Controls/Control';
import ControlViewModel from '@/ViewModels/ControlViewModel';
import LinkT from '@/Controls/Link';
import DropDownTreeViewT from '@/Controls/DropDownTreeView';
import AssociationTreeViewModel from '@/ViewModels/Controls/AssociationTreeViewViewModel';

export default class AssociationTreeView extends Control {
    private control: JQuery;
    private dropDownTreeView: DropDownTreeViewT;
    private linkCreate: LinkT;

    private DropDownTreeView = ComponentManager.getControl<typeof DropDownTreeViewT>('DropDownTreeView');
    private Link = ComponentManager.getControl<typeof LinkT>('Link');

    public constructor(private viewModel: AssociationTreeViewModel, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.control != null) {
            return this.control;
        }

        this.control = this.element || $('<div>');

        this.widget(null);

        return this.control;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.control, {
            controlName: 'associationtreeview',
            controlIdent: this.identifier,
            locator: this.viewModel.locator,
            tooltip: this.viewModel.tooltip,
            invalid: this.viewModel.invalidationText,
            visible: this.viewModel.isVisible,
            styles: this.definePureComputed({
                read: () => {
                    return ['default'];
                }
            }),
            states: this.definePureComputed({
                read: () => {
                    let states = [];
                    if (this.viewModel.isRequired() === true) states.push('required');
                    if (this.viewModel.isValid() === true) states.push('valid');
                    if (this.viewModel.isValid() !== true) states.push('invalid');
                    if (this.viewModel.isEnabled() === true) states.push('enabled');
                    if (this.viewModel.isEnabled() !== true) states.push('disabled');

                    return states;
                }
            })
        });

        if (this.viewModel.dropDownTreeView != null) {
            this.dropDownTreeView = new this.DropDownTreeView(this.viewModel.dropDownTreeView);
            let tuple = this.dropDownTreeView.getTuple();

            tuple.control.appendTo(this.control);
        }

        if (this.viewModel.linkCreate != null) {
            this.linkCreate = new this.Link(this.viewModel.linkCreate);
            let tuple = this.linkCreate.getTuple();

            tuple.control.appendTo(this.control);
        }
    }
}

ComponentManager.setControl('AssociationTreeView', AssociationTreeView, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setControl('AssoziationTreeView', AssociationTreeView, 'RADPresentation.HTMLClient.DefaultViewExtensions');